<template>
  <div :class="styleClass"
       class="pointer"
  >
    <vue-dropzone ref="myVueDropzone"
                  id="dropzone"
                  @vdropzone-sending="beforeUpload"
                  @vdropzone-success="afterUploadSuccess"
                  @vdropzone-error="afterUploadError"
                  @vdropzone-file-added="afterFileAdded"
                  :duplicate-check="true"
                  :options="dropzoneOptions"
                  :use-custom-slot="true"
    >
      <template v-if="src && !addingFile">
        <img :src="src.url"
             class="w-100"
             alt="Company profile image"
        />
        <i class="fa fa-pencil" aria-hidden="true" />
        <i class="fa fa-icon" aria-hidden="true" @click.stop="deleteImage">
          <span class="mod-icon-clear" />
        </i>
      </template>
      <template v-else-if="!addingFile">
        <div class="upload-wrapper">
          <div>
            <div><i class="fa fa-upload" /></div>
            <label v-dompurify-html="label" />
            <div class="upload-recommended"
                 v-if="recommended"
            >
              {{ recommended }}
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <!-- Show any html so the default html from dropzone package is hidden -->
        <div />
      </template>
    </vue-dropzone>
    <div class="error-text">{{ error }}</div>
  </div>
</template>

<script>
import axios from 'axios';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import store from 'store';
import toastr from 'toastr';
import Errors from '../classes/Errors';

export default {
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    label: { type: String, default: 'Browse' },
    src: { type: Object, default: null },
    styleClass: { type: String, default: 'square-upload ' },
    typeId: { type: Number, default: null },
    model: { type: String, default: '' },
    modelId: { type: Number, default: null },
    recommended: { type: String, default: '' },
  },
  data() {
    return {
      fd: [],
      dropzoneOptions: {
        url: `${process.env.API_URL}${this.model}/${this.modelId}/images`,
        headers: { Authorization: `Bearer ${store.get('jwtToken')}` },
        thumbnailWidth: null,
        maxFilesize: 2,
        maxFiles: 1,
        paramName: 'image',
      },
      addingFile: false,
      error: '',
      errors: new Errors(),
    };
  },
  methods: {
    beforeUpload(file, xhr, formData) {
      if (this.typeId) {
        formData.append('type_id', this.typeId);
      }
    },
    afterUploadSuccess() {
      this.$emit('update', this.typeId);
    },
    afterUploadError() {
      this.error = `Couldn't upload photo`;
    },
    afterFileAdded() {
      this.addingFile = true;
    },
    afterQueueComplete() {
      this.$refs.myVueDropzone.removeAllFiles();
      this.addingFile = false;
    },
    deleteImage() {
      const url = `${process.env.API_URL}${this.model}/${this.modelId}/images/${this.src.id}`;
      axios.delete(url).then(() => {
        toastr.success('Successfully deleted image');
        this.$emit('update', this.type_id);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FilesUpload.vue